import React from "react";
import InputWrapper from "../../Inputs/InputWrapper";
import FloatingLabelInput from "../../Inputs/FloatingLabelInput";
import { Controller, useFormContext } from "react-hook-form";
import { signUpFormValidators } from "../../../../helpers/signUpFormConstants";
import { useState } from "react";
import PasswordValidationLabels from "./PasswordValidationLabels";
import { SignUpFormData } from "../../../../SignUpFormTypes/signUpFormTypes";

const PasswordInput = () => {
  const { control, setFocus } = useFormContext<SignUpFormData>();
  const [showPassword, setShowPassword] = useState(false);

  const INPUT_NAME = "password";

  const handleIconClick = () => {
    setShowPassword(!showPassword);
    setFocus(INPUT_NAME);
  };

  return (
    <Controller
      name={INPUT_NAME}
      rules={signUpFormValidators.password}
      control={control}
      render={({ field, fieldState: { invalid, isTouched } }) => (
        <div className="flex flex-col gap-8 w-full">
          <InputWrapper
            label="Password"
            valid={!invalid && isTouched}
            valueExists={!!field.value}
            passwordInput={{ showPassword, handleIconClick }}
            name={INPUT_NAME}
          >
            <FloatingLabelInput
              hasError={invalid && isTouched}
              type={showPassword ? "text" : "password"}
              autoComplete="new-password"
              focusUncontrolled
              {...field}
            />
          </InputWrapper>
          <PasswordValidationLabels
            passwordHasError={invalid && isTouched}
            value={field.value}
          />
        </div>
      )}
    />
  );
};

export default PasswordInput;
